import gql from "graphql-tag";

const VERSION_FIELDS = `
	fragment versionFields on Version {
        id
        areaId
        publishedAt
        publishDate
        modifiedAt
        releaseNote
        name
        isActive
	}
`;

export const createDraftMutation = gql(`
${VERSION_FIELDS}
	mutation createDraft($areaId: String!) {
		createDraft(areaId: $areaId) {
		    ...versionFields
		}
	}
`);

export const publishDraftMutation = gql(`
${VERSION_FIELDS}
	mutation publishDraft($areaId: String!, $releaseNote: String) {
		publishDraft(areaId: $areaId, releaseNote: $releaseNote) {
		    ...versionFields
		}
	}
`);

export const versionsQuery = gql(`
${VERSION_FIELDS}
	query getVersions($areaId: String!) {
		getVersions(areaId: $areaId) {
		    ...versionFields
		}
	}
`);

export const activeVersionQuery = gql(`
${VERSION_FIELDS}
	query getActiveVersion($areaId: String!) {
		getActiveVersion(areaId: $areaId) {
		    ...versionFields
		}
	}
`);

export const activateVersionMutation = gql(`
${VERSION_FIELDS}
	mutation activateVersion($id: String!, $areaId: String!) {
		activateVersion(id: $id, areaId: $areaId) {
		    ...versionFields
		}
	}
`);

export const areaDiffQuery = gql(`
    query getAreaDiff($areaId: String!, $publishedAt: Float, $compareAt: Float) {
        getAreaDiff(areaId: $areaId, publishedAt: $publishedAt, compareAt: $compareAt) {
            publishedAt
            error
            spotsAdded {
                name
            }
            spotsRemoved {
                name
            }
            spotsModified {
                key
                name
                changes {
                    path
                    before
                    after
                }
            }
            areaChanges {
                path
                before
                after
            }
            zoneChanges {
                zoneId
                name
                changes {
                    path
                    before
                    after
                }
            }
        }
    }
`);

export const revertAreaToPublishedMutation = gql(`
    mutation revertAreaToPublished($areaId: String!) {
        revertAreaToPublished(areaId: $areaId) {
            message
        }
    }
`);

export const revertAreaToVersionMutation = gql(`
    mutation revertAreaToVersion($areaId: String!, $versionId: String!, $publishedAt: Float!) {
        revertAreaToVersion(areaId: $areaId, versionId: $versionId, publishedAt: $publishedAt) {
            message
        }
    }
`);

export const createDraftFromVersionMutation = gql(`
    mutation createDraftFromVersion($areaId: String!, $publishedAt: Float!, $publishExistingDraft: Boolean) {
        createDraftFromVersion(areaId: $areaId, publishedAt: $publishedAt, publishExistingDraft: $publishExistingDraft) {
            id
            areaId
            publishedAt
            modifiedAt
            releaseNote
            name
            isActive
        }
    }
`);
